import types from "./types";

const initialState = { selected_test: [], homeservice: 'yes' };
const selectedTestReducer = (state = initialState, action) => {

  switch (action.type) {
    case types.SELECTED_TEST:

      return {
        ...state,
        selected_test: [...state.selected_test, action.selectedTest]
      };
    case types.REMOVE_TEST:
     
      return {
        ...state,
        selected_test: state.selected_test.filter(
          (item) => item.doc.uuid !== action.value
        )
      };
    case types.CLEAR_TEST:
      return {
        ...state,
        selected_test: []
      }
    case types.REMOVEFEATURETEST:
      return {
        ...state,
        selected_test: state.selected_test.filter(
          (item) => item.uuid !== action.value
        )
      }

    default:
      return state;
  }
};

export default selectedTestReducer;
// selected_test: state.selected_test.splice(
//     state.selected_test.findIndex((e) => e._id === action.value),
//     1
//   ),
